import { ILoginState } from './type'
import { IRootState } from '../type'
import { Module } from 'vuex'
import { ElNotification } from 'element-plus'
import {
  accountLoginRequest,
} from '@/service/login/login'
import router from '@/router'
import LocalCache from '@/utils/cache'
import { IAccount } from '@/service/login/type'
import store from '@/store'
const axios = require('axios')
import { RouteRecordRaw } from 'vue-router'

const loginModule: Module<ILoginState, IRootState> = {
  namespaced: true,
  state() {
    return {
      token: '',
      userInfo: {},
      userMenus: [],
      permissions: []
    }
  },
  getters: {},
  actions: {
    async accountLoginAction({ commit, dispatch }, payload: IAccount) {
      // 1.实现登录逻辑
      const loginResult = await accountLoginRequest(payload)
      if (loginResult.code === 200) {
        const { access_token: token } = loginResult.data
        console.log('登录成功，获取到token:', token)

        LocalCache.setCache('token', token)
        commit('changeToken', token)

        // 同步token到根store
        commit('SET_TOKEN', token, { root: true })

        console.log('Token已存储 - localStorage:', LocalCache.getCache('token'), '根store:', store.state.token)

        // 发送初始化的请求(完整的role/department)
        //dispatch('getInitiaDataAction', null, { root: true })

        // 3.请求用户菜单
        // const userMenusResult = await RequestMenuById(userInfo.role.id)

        // 4.跳转到主页，让路由守卫处理跳转到第一个可访问的路由
        //router.push('/main')
        store.dispatch('GetInfo').then(() => {
          store.dispatch('permission/GenerateRoutes').then((accessRoutes: RouteRecordRaw[]) => {
            console.log('accessRoutes', accessRoutes)
            // 如果是访问根路径或主页，跳转到第一个可访问的路由
            const firstRoute = getFirstAccessibleRoute(accessRoutes)
            console.log('跳转到第一个可访问路由:', firstRoute)
            router.push(`${firstRoute}`)
          })
        })
      } else {
        return ElNotification({
          title: '错误',
          message: loginResult.msg,
          type: 'error',
        })
      }
    },
    loadLocalLogin({ commit, dispatch }) {
      const token = LocalCache.getCache('token')
      console.log('loadLocalLogin - token:', token)
      if (token) {
        commit('changeToken', token)
        // 同步token到根store
        commit('SET_TOKEN', token, { root: true })
        // 发送初始化的请求(完整的role/department)
        //dispatch('getInitiaDataAction', null, { root: true })
      }
      // const userInfo = LocalCache.getCache('userInfo')
      // if (userInfo) {
      //   commit('changeUserInfo', userInfo)
      // }
      //const userMenus = LocalCache.getCache('userMenus')
      //if (userMenus) {
      //  commit('changeUserMenus', userMenus)
      //}
    }
  },
  mutations: {
    changeToken(state, token: string) {
      state.token = token
    },
    changeUserInfo(state, userInfo: any) {
      state.userInfo = userInfo
    },
  }
}
// 获取第一个可访问的路由
function getFirstAccessibleRoute(routes: RouteRecordRaw[]): string | null {
  for (const route of routes) {
    // 跳过隐藏的路由和根路径
    if (route.meta?.hidden || route.path === '/' || route.path === '/main') {
      continue
    }

    // 如果有子路由，递归查找第一个可访问的子路由
    if (route.children && route.children.length > 0) {
      const childRoute = getFirstAccessibleRoute(route.children)
      if (childRoute) {
        // 如果父路由有路径，需要拼接
        if (route.path && route.path !== '/') {
          return route.path + '/' + childRoute.replace(/^\//, '')
        }
        return childRoute
      }
    } else {
      // 没有子路由，返回当前路由路径
      return route.path
    }
  }
  return null
}
export default loginModule
